export default __webpack_public_path__ + "static/media/story-SLIDE_2.e37d95a3.jpg";